import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { httpOk, DELETE, GET, POST, PUT } from 'helpers/api'
import PageHeader from './PageHeader'
import ValidPeriod from './ValidPeriod'
import { formatMoneyInput } from 'helpers/helpers'

function CreateUpdateFirstOrder() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [poses, setPoses] = useState([])
	const [orderTypeSubs, setOrderTypeSubs] = useState([])
	const [data, setData] = useState({
		name: '',
		discount_payment_type: 2,
		discount_payment_value: '',
		days: [],
		poses: [],
		order_type_subs: [],
	})

	async function createUpdate() {
		const dataCopy = { ...data }

		let response
		if (!dataCopy.id) {
			response = await POST('/discount/services-first-order', dataCopy, { loader: true })
		} else {
			response = await PUT('/discount/services-first-order', dataCopy, { loader: true })
		}
		if (httpOk(response)) navigate('/discount/services')
	}

	function handleChangeTime(e, index, type) {
		const dataCopy = { ...data }
		dataCopy.days[index][type] = e.target.value
		setData(dataCopy)
	}

	function setDayStatus(index, key) {
		const dataCopy = { ...data }
		dataCopy.days[index][key] = !dataCopy.days[index][key]
		setData(dataCopy)
	}

	function addTime() {
		const dataCopy = { ...data }
		dataCopy.days.push({
			start_time: '',
			end_time: '',
			day1: false,
			day2: false,
			day3: false,
			day4: false,
			day5: false,
			day6: false,
			day7: false,
		})
		setData(dataCopy)
	}

	async function deleteDay(item, index) {
		const dataCopy = { ...data }
		if (item.id) {
			const response = await DELETE(`/discount/services-promo-day/${item.id}`, {}, { loader: true })
			if (httpOk(response)) dataCopy.days.splice(index, 1)
		} else {
			dataCopy.days.splice(index, 1)
		}
		setData(dataCopy)
	}

	async function getData() {
		const responsePoses = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(responsePoses)) setPoses(responsePoses.data)

		const responseOrderTypeSubs = await GET('/helper/order-type-subs', {}, {})
		if (httpOk(responseOrderTypeSubs)) setOrderTypeSubs(responseOrderTypeSubs.data)

		if (id) {
			const response = await GET(`/discount/services-first-order/${id}`, {}, { loader: true })
			if (httpOk(response)) setData(response.data)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<PageHeader typeKey="discount_automatic_first_order" />

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4 border-right">
							<div className="form-group">
								<label>{t('name2')}</label>
								<input type="text" className="form-control"
									value={data.name ?? ''}
									onChange={(e) => setData({ ...data, name: e.target.value })} />
							</div>
							<ValidPeriod data={data} setData={setData} />
							<div className="form-group">
								<label>{t('poses')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									value={data.poses}
									options={poses}
									onChange={(options) => setData({ ...data, poses: options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setData({ ...data, discount_payment_type: 2 })}
										style={{ backgroundColor: data.discount_payment_type === 2 ? 'black' : '' }} />
									<span onClick={() => setData({ ...data, discount_payment_type: 2 })}>
										{t('percentage')}
									</span>
								</div>
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setData({ ...data, discount_payment_type: 1 })}
										style={{ backgroundColor: data.discount_payment_type === 1 ? 'black' : '' }} />
									<span onClick={() => setData({ ...data, discount_payment_type: 1 })}>
										{t('amount')}
									</span>
								</div>
							</div>

							<div className="form-group w-100">
								<label>{t('discount_value')}</label>
								<input type="text" className="form-control"
									value={formatMoneyInput(data.discount_payment_value) ?? ''}
									onChange={(e) => setData({ ...data, discount_payment_value: e.target.value.replace(/[^0-9.]/g, '') })} />
							</div>
							<div className="form-group">
								<label>{t('order_type')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									value={data.order_type_subs}
									options={orderTypeSubs}
									onChange={(options) => setData({ ...data, order_type_subs: options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>
						<div className="col-md-8">
							<div className="form-group">
								<div className="d-flex gap-2 mb-2">
									<h4 className="fw-600">{t('discount_day_time')}</h4>
									<div className="table-action-button table-action-primary-button" onClick={() => addTime()}>
										<i className="uil-plus"></i>
									</div>
								</div>
								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th>{t('start')}</th>
												<th>{t('end')}</th>
												<th>{t('monday_short')}</th>
												<th>{t('tuesday_short')}</th>
												<th>{t('wednesday_short')}</th>
												<th>{t('thursday_short')}</th>
												<th>{t('friday_short')}</th>
												<th>{t('saturday_short')}</th>
												<th>{t('sunday_short')}</th>
												<th style={{ width: 50 }}></th>
											</tr>
										</thead>
										<tbody>
											{data?.days?.map((item, index) => (
												<tr key={index}>
													<td>
														<input type="time" className="form-control" value={item.start_time ?? ''}
															onChange={(e) => handleChangeTime(e, index, 'start_time')} />
													</td>
													<td>
														<input type="time" className="form-control" value={item.end_time ?? ''}
															onChange={(e) => handleChangeTime(e, index, 'end_time')} />
													</td>
													{['day1', 'day2', 'day3', 'day4', 'day5', 'day6', 'day7'].map((dayKey) => (
														<td className="vertical-middle" key={dayKey}>
															<input type="checkbox" className="form-check-input"
																checked={item[dayKey] ?? false}
																onChange={() => setDayStatus(index, dayKey)} />
														</td>
													))}
													<td>
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteDay(item, index)}>
															<i className="uil-times"></i>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/discount/services">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide" onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default CreateUpdateFirstOrder
